import { createSlice } from "@reduxjs/toolkit";
import {
  fetchClassesBuilder,
  createClassBuilder,
  editClassBuilder,
  deleteClassBuilder,
  fetchTeacherClassesBuilder,
} from "./builder";

const initialState = {
  classes: {
    data: [],
    teacherClasses: [],
  },
  fetchClassesPending: false,
  editClassPending: false,
  createClassPending: false,
  deleteClassPending: false,
};

export const classesSlice = createSlice({
  name: "classes",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    fetchClassesBuilder(builder);
    fetchTeacherClassesBuilder(builder);
    createClassBuilder(builder);
    editClassBuilder(builder);
    deleteClassBuilder(builder);
    builder.addCase("logout", () => initialState);
  },
});

export const selectClasses = (state) => state.classes.classes;
export const selectTeacherClasses = (state) =>
  state.classes.classes.teacherClasses;
export const selectEditClassPending = (state) => state.classes.editClassPending;
export const selectCreateClassPending = (state) =>
  state.classes.createClassPending;
export const selectDeleteClassPending = (state) =>
  state.classes.deleteClassPending;
export default classesSlice.reducer;
